// Use store that contain:
// 1. commonStoreModule
// 2. service store
// those are assign to window.xbase namespace
// inside './index.js' file
import store from "./index.js";

const initializedStore = new window.Vuex.Store(store);

if (process.env.NODE_ENV === "development") {
  window.xbase = {};
  window.xbase.commonStoreModules = initializedStore; // for old env
}

export default initializedStore;
